// Override Settings
var boostPFSFilterConfig = {
    general: {
        limit: boostPFSConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        paginationTypeAdvanced: false,
        extraSortingList: 'extra-sort1-ascending|extra-sort1-descending',
    },
};

// Declare Templates
var boostPFSTemplate = {
    saleLabelHtml: '<div class="sale-badge">' + boostPFSConfig.label.on_sale + "</div>",
    soldOutLabelHtml: '<div class="sold-out-badge">' + boostPFSConfig.label.sold_out + "</div>",
    vendorHtml: '<div class="product-grid--vendor-text">{{itemVendorLabel}}</div>',
    metaHtml: '<p  class="product-grid--meta-data">{{itemMetaLabel}}</p>',
    // Grid Template
    productGridItemHtml: 	'<div class="grid__item ' + boostPFSConfig.custom.grid_item_width + ' grid__item-{{itemId}}">' +
								        		'<div class="grid-view-item">' +
								        			'<div class="grid-view-item-image">' +
								        				"{{itemImages}}" +
								        				"{{itemQuickview}}" +
								        			'</div>' +
								        			'<div class="grid-view-item--desc-wrapper grid-uniform">' +
								        				'<div class="grid__item large--one-whole">' +
								        					'{{itemVendor}}' +
								        					'{{itemReviews}}' +

													        '<p class="product-grid--meta-data">' +
													        	'{{itemMeta}}' +
													        '</p>' +

								        					'<div class="boost-pfs-bottom-info">' +
												        			'<p class="product-grid--title">' +
												        				'<a href="{{itemUrl}}">{{itemTitle}}</a>' +
												        			'</p>' +
												        			'<p class="product-grid--price">' +
												        				'{{itemPrice}}' +
												        			'</p>' +
												        	'</div>' +
												        	'{{itemFlairHtml}}' +
												        '</div>' +
											        '</div>' +
											        '{{itemBadges}}' +
										        '</div>' +
								        '</div>',

    // Pagination Template
    previousActiveHtml: '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-left"></i></a></li>',
    previousDisabledHtml: '<li class="prev disabled"><a href="#" onclick="return false;">&laquo;</a></li>',
    nextActiveHtml: '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-right"></i></a></li>',
    nextDisableHtml: '<li class="next disabled"><a href="#" onclick="return false;">&raquo;</a></li>',
    pageItemHtml: '<li class="pagination-number"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
    pageItemSelectedHtml: '<li class="active pagination-number"><a href="" title="">{{itemTitle}}</a></li>',
    pageItemRemainHtml: '<li class="ellipsis">{{itemTitle}}</li>',
    paginateHtml: "<ul>{{previous}}{{pageItems}}{{next}}</ul>",

    // Sorting Template
    sortingHtml: '<label for="bc-sf-filter-top-sorting-select">' + boostPFSConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>',
};

(function() {
    // Add this
    BoostPFS.inject(this); // Add this

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {

        if (!data) data = this.data; // Add this line
        if (!index) index = this.index; // Add this line
        if (!totalProduct) totalProduct = this.totalProduct;

        var soldOut = !data.available;
        var onSale = data.compare_at_price_min > data.price_min;
        var priceVaries = data.price_min != data.price_max;
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add class
        // Add Badges
        var itemBadgesHtml = "";
        if (boostPFSConfig.custom.enable_sale_badge && onSale && data.available) {
            itemBadgesHtml += boostPFSTemplate.saleLabelHtml;
        }
        if (boostPFSConfig.custom.enable_sold_out_badge && !data.available) {
            itemBadgesHtml += boostPFSTemplate.soldOutLabelHtml;
        }
        itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

        // Add Vendor
        var itemVendorHtml = boostPFSConfig.custom.show_vendor ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : "";
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        if (Utils.getProductMetafield(data, 'my_fields', 'product_metadata') !== null) {
            var itemMetaHtml = Utils.getProductMetafield(data, 'my_fields', 'product_metadata');
        } else {
            var itemMetaHtml = '';
        }
        itemHtml = itemHtml.replace(/{{itemMeta}}/g, itemMetaHtml);


        // Add price
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data, soldOut, onSale, priceVaries));

        // Add Reviews
        //var itemReviewsHtml = boostPFSConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>': "";
        //itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);


        // Add Images
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

        // Add Quick view
        itemHtml = itemHtml.replace(/{{itemQuickview}}/g, buildHover(data));

        // Add main attribute
        //itemHtml = itemHtml.replace(/{{itemMeta}}/g, data.metafields.my_fields.product_metadata);
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);

        if (data.tags.filter(tag => tag.indexOf("collection-image-block: no link") != -1).length == 1) {
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, '');
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, 'javascript: void(0)');
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
        } else if (data.tags.filter(tag => tag.indexOf("collection-image-block: link") != -1).length == 1) {
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, '');
            var urforCard = data.tags.filter(tag => tag.indexOf("url: ") != -1)[0]
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, urforCard.slice(4));
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
        }

        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

        var itemReviewsHtml = '';
        var itemReviewsHtml = '<div class="klaviyo-star-rating-widget" data-id="{{itemId}}" data-product-title="{{itemTitle}}" data-product-type="{{itemType}}"></div>'
        itemReviewsHtml = itemReviewsHtml.replace(/{{itemTitle}}/g, data.title);
        itemReviewsHtml = itemReviewsHtml.replace(/{{itemId}}/g, data.id);
        itemReviewsHtml = itemReviewsHtml.replace(/{{itemType}}/g, data.product_type);
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

        itemHtml = itemHtml.replace(/{{itemFlairHtml}}/g, '<div data-flair-product-badge data-product-id="' + data.id.toString() + '"></div>');
        return itemHtml;
    };

    function buildImages(data) {
        var images = data.images_info;
        var html = "";
        if (boostPFSConfig.custom.hover_effect) {
            if (images.length > 1) {
                html += '<div class="reveal">';
                html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
                html += '<img src="' + Utils.optimizeImage(images[0]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn featured-image" id="collection-image-anim">';
                html += '<div class="hidden">';
                html += '<img src="' + Utils.optimizeImage(images[1]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive" />';
                html += "</div>";
                html += "</a>";
                html += "</div>";
            } else {
                html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
                html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
                html += "</a>";
            }
        } else {
            html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
            html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
            html += "</a>";
        }
        return html;
    }

    function buildHover(data) {
        var html = "";
        if (boostPFSConfig.custom.quick_shop_enable) {
            html += '<div class="shop-now-wrapper">';
            html += '<a class="shop-now-button" href="{{itemUrl}}">' + boostPFSConfig.label.quick_shop + '</a>';
            html += '</div>';
        }
        return html;
    }

    function buildPrice(data, soldOut, onSale, priceVaries) {
        var html = '';
        if (onSale) {
            if (priceVaries) {
                html += boostPFSConfig.label.sale_from_price.replace(/{{ price }}/g, '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>');
            } else {
                html += ' <span class="product-grid--origin-price">' + Utils.formatMoney(data.price_min) + ' </span>';
                html += '<span class="product-grid--compare-price">' + Utils.formatMoney(data.compare_at_price_min) + "</span>";
            }
        } else {
            if (priceVaries) {
                html += ' <span class="product-grid--from-wrapper">' + boostPFSConfig.label.from_price + '</span> <span class="money">' + Utils.formatMoney(data.price_min) + "</span>";
            } else {
                html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
            }
        }
        if (soldOut) {
            html += '<br><strong>' + boostPFSConfig.label.sold_out + '</strong>';
        }

        var html2 = ""
        if (data.tags.filter(tag => tag.indexOf("collection-image-block: no link") != -1).length == 1) {
            return html2
        } else if (data.tags.filter(tag => tag.indexOf("collection-image-block: link") != -1).length == 1) {
            return html2
        } else {
            return html;
        }
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (Settings.getSettingValue("general.paginationType") == "default" && totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift("...");
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push("...");
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = "";
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == "...") {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = "";
                sortingItemsHtml += '<option value="">Popular</option>';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + "</option>";
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    ProductSorting.prototype.render = function() {
        jQ(Selector.topSorting).html(this.compileTemplate());


        var paramSort = Globals.queryParams.sort || '';
        if (paramSort.length > 0 && Utils.getSortingList()[paramSort]) {
            jQ(Selector.topSorting).find('select').val(paramSort);
        } else {
            jQ(Selector.topSorting).find('select').val('');
        }
    }

    ProductSorting.prototype.bindEvents = function() {
        var _this = this;
        jQ(Selector.topSorting).find('select').change(function(e) {
            e.preventDefault();
            var sort = jQ(this).val();

            if (!sort) sort = boostPFSConfig.general.default_sort_by;

            FilterApi.setParam('sort', sort);
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter('sort');

        });
    }

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;

        if (typeof FlairApp !== 'undefined' && FlairApp) {
            FlairApp.refreshProductBadges();
        }

        // if(data.filter(da => da.tags.indexOf("collection-image-block: no link") != -1).length == 1){
        //   console.log('Hi')
        //   jQ('.large--one-whole').addClass('imageBlock')
        // }
        // console.log(data.filter(da => da.tags.indexOf("collection-image-block: no link") != -1).length )

        //Call theme function
        if (window.wetheme && typeof wetheme.load_all == "function") {
            wetheme.load_all({});
        }
        buildTheme();
    };

    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (Utils.isSearchPage()) {
            var searchText = 'Search: ' + data.total_product + ' results found for "' + Utils.getSearchTerm() + '"';
            jQ('.breadcrumb span:last-child').text(searchText);
        }
    };

    function buildTheme() {
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }
        Shopify.PaymentButton.init();

        if (boostPFSConfig.custom.show_multiple_currencies) {
            convertCurrencies();
        }
    }

    var filterSortValues = FilterOption.prototype.sortValues;
    var manualSizeOrder = ['OS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
    FilterOption.prototype.sortValues = function(values) {
        if (this.filterOptionId === 'pf_t_size') {
            if (values && values.length > 0) {
                values.sort(function(a, b) {
                    var idx1 = manualSizeOrder.indexOf(a.key.replace('pfs-size:', ''));
                    var idx2 = manualSizeOrder.indexOf(b.key.replace('pfs-size:', ''));

                    if (idx1 == -1) return 1;

                    return idx1 - idx2;
                });
            }
        } else {
            filterSortValues.call(this, values);
        }
    }
})();



/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit = function() {
    var t = this.isBadUrl();
    t && (this.isInit = !0, window.location.href = window.location.pathname)
}, Filter.prototype.isBadUrl = function() {
    try {
        var t = decodeURIComponent(window.location.search).split("&"),
            e = !1;
        if (t.length > 0)
            for (var n = 0; n < t.length; n++) {
                var i = t[n],
                    r = (i.match(/</g) || []).length,
                    a = (i.match(/>/g) || []).length,
                    o = (i.match(/alert\(/g) || []).length,
                    h = (i.match(/execCommand/g) || []).length;
                if (r > 0 && a > 0 || r > 1 || a > 1 || o || h) {
                    e = !0;
                    break
                }
            }
        return e
    } catch (l) {
        return !0
    }
};
/* End patch boost-010 run 2 */